import React from 'react'
import { DataContainer, SettingContainer } from './styled'
import { AccordionMenu } from '@sabavision/dio'
import AccountSetting from './Setting/AccountSetting'
import SecuritySetting from './Setting/SecuritySetting'
import Notifications from './Setting/Notifications'
import ViewSetting from './Setting/ViewSetting'
import { useTranslation } from 'react-i18next'

function Setting() {
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  return (
    <DataContainer className="align-stretch">
      <SettingContainer>
        <AccordionMenu
          label={t('account_setting')}
          icon="iconsax-user-square"
          handleClick={() => {
            console.log()
          }}
        >
          <AccountSetting />
        </AccordionMenu>
        <AccordionMenu
          label={t('security_setting')}
          icon="iconsax-key-square"
          handleClick={() => {
            console.log()
          }}
        >
          <SecuritySetting />
        </AccordionMenu>
        <AccordionMenu
          label={t('notifications')}
          icon="iconsax-notification-favorite"
          handleClick={() => {
            console.log()
          }}
        >
          <Notifications />
        </AccordionMenu>
        <AccordionMenu
          label={t('view_setting')}
          icon="iconsax-colors-square"
          handleClick={() => {
            console.log()
          }}
        >
          <ViewSetting />
        </AccordionMenu>
      </SettingContainer>
    </DataContainer>
  )
}

export default Setting
